import React from "react";
import { ArrowUpRight } from "lucide-react";

import { retrySubscription } from "../../api/client";
import styles from "../auth/authBoundary.module.css";


// 「重新检查」后端返回 outcome 的用户话术。只有 renewed（订阅恢复）会离开这个页面。
const OUTCOME_MESSAGES = {
  insufficient_credits: "光点仍然不足。请先在 Lucimix 侧栏充值，再点击「重新检查」。",
  cooldown: "刚刚检查过了，请稍等几秒再试。",
  no_identity: "该账号没有绑定 Lucimix，无法自动扣费，请联系管理员。",
  canceled: "订阅已取消，请联系管理员。",
};
const UNAVAILABLE_MESSAGE = "订阅服务暂时不可用，请稍后重试。";


/**
 * 订阅已到期/已取消时代替应用页面（后端对业务接口统一 403）。
 * 到期（lapsed）：用户去 Lucimix 充值后点「重新检查」，后端立即补扣，成功就回到应用。
 * 取消（canceled）：只有管理员能恢复，不给按钮。
 */
export function SubscriptionGate({ code, details, onRecovered }) {
  const canceled = code === "subscription_canceled";
  const [checking, setChecking] = React.useState(false);
  const [message, setMessage] = React.useState("");

  async function handleRetry() {
    if (checking) return;
    setChecking(true);
    setMessage("");
    try {
      const result = await retrySubscription();
      if (result?.status === "active") {
        onRecovered();
        return;
      }
      setMessage(OUTCOME_MESSAGES[result?.outcome] ?? UNAVAILABLE_MESSAGE);
    } catch {
      setMessage(UNAVAILABLE_MESSAGE);
    } finally {
      setChecking(false);
    }
  }

  return (
    <main className={styles.authPage} id="main-content">
      <section className={styles.loginCard} aria-labelledby="subscription-gate-title">
        <div className={styles.loginBrand}>
          <span className={styles.loginBrandMark}><ArrowUpRight size={24} aria-hidden="true" /></span>
          <span>Astock Agent</span>
        </div>
        <h1 id="subscription-gate-title">{canceled ? "订阅已取消" : "订阅已到期"}</h1>
        <p className={styles.loginLead}>
          {canceled
            ? "该账号的订阅已被取消，暂时无法使用。请联系管理员。"
            : "月度订阅已到期，暂时无法使用。请在 Lucimix 侧栏为光点充值，然后点击「重新检查」。"}
        </p>
        {details?.current_period_end && !canceled && (
          <p className={styles.loginLead}>到期日：{details.current_period_end}</p>
        )}
        {(message || !canceled) && (
          <div className={styles.loginForm}>
            {message && <p className={styles.loginError} role="alert">{message}</p>}
            {!canceled && (
              <button className={styles.loginButton} type="button" onClick={handleRetry} disabled={checking}>
                {checking ? "检查中…" : "我已充值，重新检查"}
              </button>
            )}
          </div>
        )}
      </section>
    </main>
  );
}
